import React from "react";
import styled from "styled-components";

const StyledMUITextFieldDatePicker = styled.div`
  input {
    border-radius: 8px !important;
    height: 50px;
    min-width: 150px;
    padding: 12px 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: none;
    color: var(--colorTextPrimary);
    font-family: var(--primaryTextFont);
    font-size: 14px;
    background-color: white;
    box-shadow: inset 0 0 0 1px var(--colorBorder);
  }

  input:hover {
    box-shadow: inset 0 0 0 2px var(--colorBorder);
  }

  input:focus {
    box-shadow: inset 0 0 0 2px var(--primaryColor);
  }
`;

export const DatePicker = ({
  id,
  name = "",
  value,
  min,
  max,
  ariaLabel,
  placeholder,
  disabled = false,
  required = false,
  onChange = () => {},
  onFocus = () => {},
}) => {
  return (
    <StyledMUITextFieldDatePicker className="mui-datepicker">
      <input
        type="date"
        className="input-calendar-field"
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        {...(ariaLabel ? { "aria-label": ariaLabel } : {})}
        {...(required ? { required: true } : {})}
        {...(disabled ? { disabled: true } : {})}
        {...(min && { min })}
        {...(max && { max })}
        onChange={onChange}
        onFocus={onFocus}
      />
    </StyledMUITextFieldDatePicker>
  );
};
